/**
 * Mode to record for an agent when cloud start settles.
 *
 * Pre-fix this read `(this.#mode[idHex] ?? isElectronApp()) ? 'local' : 'cloud'`
 * — mis-parenthesised: `#mode[idHex]` is a NON-EMPTY STRING ('local' | 'cloud')
 * whenever seeded, so the ternary condition was truthy for a seeded 'cloud'
 * and force-flipped it to 'local' after every cloud start. The intent (and
 * what every other reader implements via `modeForAgent`'s `?? 'cloud'` /
 * `#preferenceMode` defaulting) is: KEEP a seeded mode; only an UNSEEDED agent
 * takes the platform default (electron boots local, web boots cloud).
 * Own module so the unit suite imports it without livekit.ts's transitive store deps (livekit.start-cloud-mode.test.ts).
 * Per rule: ai-code-requires-tests + reference-rules-in-comments (ai.knowledge/global).
 *
 * @param existing - The agent's seeded mode, if any.
 * @param isElectron - Whether this client is the Electron app.
 * @returns The mode to record.
 */
export const resolveStartCloudMode = (
  existing: 'local' | 'cloud' | undefined,
  isElectron: boolean
): 'local' | 'cloud' => existing ?? (isElectron ? 'local' : 'cloud');
